import React from 'react';
import { Container } from 'reactstrap';
import CrudList from './list';

const Orgao = () => (
  <div className="containerInside__wrap">
    <Container>
      <CrudList />
    </Container>
  </div>
);

export default Orgao;